<script>
    import NauiInput from "../../../../naui/atoms/NauiInput.svelte";
    import NauiButton from "../../../../naui/atoms/NauiButton.svelte";
    import NauiDatePicker from "../../../../naui/atoms/NauiDatePicker.svelte";
    import NauiSelect from "../../../../naui/atoms/NauiSelect.svelte";

    export let parametros_step_1;
</script>
<fieldset>
    <legend>Datos del tomador</legend>
    <div class="grid-5 gap-1">
        <NauiSelect label="Tipo de documento"
                    options={parametros_step_1.documentos}
        />
        <NauiInput label="No. Identificación"/>
        <NauiInput label="Placa"/>
    </div>
</fieldset>
<fieldset>
    <legend>Datos del siniestro</legend>
    <div class="grid-5 gap-1">
        <NauiDatePicker label="Fecha del siniestro"/>
        <NauiInput label="Hora siniestro"/>
    </div>
</fieldset>
<NauiButton caption="Continuar" color="accent" mode="solid" className="min-w-200px" on:click/>